import { render } from "./SVGSideShelfLeft.vue?vue&type=template&id=480530a7"
const script = {}

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__